import { useSession } from "@src/appV2/Auth/api/useSession";
import { useAccountsPricing } from "@src/appV2/ExperimentalHomeHealth/Cases/api/useAccountsPricing";
import {
  type PricingType,
  type VisitType,
  type WorkerRequirements,
} from "@src/appV2/ExperimentalHomeHealth/Cases/types";
import {
  getRateConfiguration,
  type RateConfiguration,
} from "@src/appV2/ExperimentalHomeHealth/lib/rateConfigurationUtils";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

const DEFAULT_VISIT_RATE_SETTING_CONFIG = {
  maxChargeRate: { perHour: 20_000, perVisit: 50_000 },
  minChargeRate: { perHour: 1_500, perVisit: 1_300 },
  takePercent: 11,
  useRateSheet: true,
};

export function useRateConfiguration(params: {
  workerRequirements: WorkerRequirements | undefined;
  pricingType: PricingType | undefined;
  visitType: VisitType | undefined;
  patientAddress: string | undefined;
}): RateConfiguration {
  const visitRateSettingConfig = useCbhFlag(CbhFeatureFlag.CONFIGURE_VISIT_RATE_SETTING, {
    defaultValue: DEFAULT_VISIT_RATE_SETTING_CONFIG,
  });
  const session = useSession();
  const { data: accountPricingList } = useAccountsPricing();
  return getRateConfiguration({ ...params, visitRateSettingConfig, session, accountPricingList });
}
